module.exports = __webpack_public_path__ + "static/media/galen-crout.6dad13a8.jpg";